export default __webpack_public_path__ + "static/media/background-onshore.2ff74b18.svg";